module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAABQBAMAAAAgtay6AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAVUExURewAFf//APFMDu8qEfzfAvmvBvV8Civ7oLEAAAESSURBVFjD7ZY9EoIwEIUdIPSLgVoZ6QU8gOgFYLwA3P8SEn4kEQr2pdGZvI7im2ze7r5wODg5Of2PWgvWf1rAXmIBi9gCDuiKw2c64XBDNQ5XdMfNJopgOCSKLcwmCcM5EW5318M13imC7fZ7FrY7VDB3NUqlokgzBct00k7nLrQhuRP2qw34xbqsqYSzit9izMqqcFaWCZONuRmii5nARuEPdnDCRc8rBRU9ZRC7xetJQZLoc2kkiW7IdK073WIZNApIomVKIqxTMsN6NXSqHkaFb3cwHump6tmPdD7FlkDs7ubHogNejWb2qS/8yIWXrBXsXnla1nbc1RCJnircTunbIJirURpfFn9jTk5OTr+qNwBIJgDYvSUvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/vn.png
// module id = 467
// module chunks = 0